// ======================================================================
// File Name       : ContentQuestionEditBigFooter
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, FormControl, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { htmlEntities } from '../../utils';

class ContentQuestionEditBigFooter extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onCheckBox = this.onCheckBox.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.onInputChange(name, value);
    } else {
      this.props.onInputChange(event, data);
    }
  }
  onCheckBox(event) {
    this.props.onCheckBoxChange(event);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    const {
      limitTime,
      onInputChange,
      openOrCloseSetting,
      onOpenOrCloseSetting,
      onOkBtnClick,
      sankakuUseDistinct,
      explanationUse,
      explanationHtmlUse,
      explanationContent,
      explanationZipFileName,
      onFileChange,
      hintUse,
      hintContent,
      hintHtmlUse,
      hintZipFileName,
      questionAttributeList,
    } = this.props;
    this.refsToValidate = [];
    let contentSetting = null;
    let buttonText = null;
    let contentExplanation = null;
    let showQuestionAttributes = null;
    const arrayQuestionAttribute = questionAttributeList;
    const thead = [
      { title: '問題属性名（問題属性ID）', width: 220, sortBy: null },
      { title: '個別問題属性名（個別問題属性ID）', sortBy: null },
    ];
    showQuestionAttributes = arrayQuestionAttribute && arrayQuestionAttribute.length > 0 && arrayQuestionAttribute.map((questionAttribute, index) => (
      <tr key={index}>
        <td>
          {questionAttribute.questionAttributeName}&nbsp;({questionAttribute.questionAttributeId})
        </td>
        <td>
          {questionAttribute.eachQuestionAttributeName}&nbsp;({questionAttribute.eachQuestionAttributeId})
        </td>
      </tr>
    ));
    if (explanationHtmlUse === '0') {
      contentExplanation = (
        <FormControlValidate
          as="textarea"
          className="textArea"
          name="explanationContent"
          onChange={this.onChange}
          disabled={!explanationUse}
          value={explanationContent ? htmlEntities(explanationContent) : ''} // #6952
          maxLength="30000"
          required={explanationUse}
          label="内容"
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
      );
    } else if (explanationHtmlUse === '1') {
      const showFileName = (
        <Col sm={12} as={Form.Label} className="padding-left-right-clear">
          <FormControlValidate
            label="ファイル名"
            validateType={VALIDATE_TYPE.LABEL}
            value={explanationZipFileName && `ファイル名：${explanationZipFileName}`}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            required={explanationUse}
          />
        </Col>
      );
      contentExplanation = (
        <div>
          <Col sm={12} className="padding-left-right-clear">
            <FileUpload
              labelName="ファイル選択"
              disabled={!explanationUse}
              inputId={'explanationZipFileName'}
              onChange={this.props.onFileChange}
              accept={'application/zip,application/x-zip,application/x-zip-compressed'}
              fileName={explanationZipFileName}
            />
          </Col>
          {showFileName}
        </div>
      );
    }
    let contentHint = null;
    if (hintHtmlUse === '0') {
      contentHint = (
        <FormControlValidate
          as="textarea"
          className="textArea"
          name="hintContent"
          onChange={this.onChange}
          disabled={!hintUse}
          value={hintContent ? htmlEntities(hintContent) : ''} // #6952
          maxLength="30000"
          required={hintUse}
          label="内容"
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
      );
    } else if (hintHtmlUse === '1') {
      const showFileName = (
        <Col sm={12} as={Form.Label} className="padding-left-right-clear">
          <FormControlValidate
            label="ファイル名"
            validateType={VALIDATE_TYPE.LABEL}
            value={hintZipFileName && `ファイル名：${hintZipFileName}`}
            ref={(ref) => {
              if (ref) {
                this.refsToValidate.push(ref);
              }
            }}
            required={hintUse}
          />
        </Col>
      );
      contentHint = (
        <div>
          <Col sm={12} className="padding-left-right-clear">
            <FileUpload
              labelName="ファイル選択"
              disabled={!hintUse}
              inputId={'hintZipFileName'}
              accept={'application/zip,application/x-zip,application/x-zip-compressed'}
              onChange={onFileChange}
              fileName={hintZipFileName}
            />
          </Col>
          {showFileName}
        </div>
      );
    }
    if (openOrCloseSetting == true) {
      buttonText = 'minute';
      contentSetting = (
        <div>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label}>
                制限時間
              </Col>
              <Col sm={7}>
                <FormControlValidate
                  type="text"
                  name="limitTime"
                  value={limitTime}
                  onChange={this.onChange}
                  maxLength="4"
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  validateType={VALIDATE_TYPE.MAX_NUMBER}
                  maxNumber="3600"
                  label="制限時間"
                />
              </Col>
              <Col as={Form.Label}>
                秒
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label}>
                解答解説を使用する
              </Col>
              <Col sm={2}>
                <Form.Check
                  type='checkbox'
                  className="margin-top-10"
                  checked={explanationUse}
                  name="explanationUse"
                  id="explanationUse"
                  onChange={this.onCheckBox} />
              </Col>
            </Col>
          </Form.Group>
          {explanationUse && (
            <Form.Group className="form-info">
              <Col sm={12} className="padding-left-right-clear">
                <Col as={Form.Label} sm={2} />
                <Col as={Form.Label} sm={2} className="form-label">内容</Col>
                <Col sm={7}>
                  <Col sm={12} className="padding-left-right-clear">
                    <Col sm={6} className="padding-left-right-clear">
                      <Form.Check
                        type='radio'
                        className="padding-top-10"
                        inline
                        name="explanationHtmlUse"
                        id="explanationHtmlUse-0"
                        value={0}
                        disabled={!explanationUse}
                        checked={explanationHtmlUse == 0}
                        onChange={this.onChange}
                        label='HTMLを使用しない'></Form.Check>
                    </Col>
                    <Col sm={6} className="padding-left-right-clear">
                      <Form.Check
                        type='radio'
                        className="padding-top-10"
                        inline
                        name="explanationHtmlUse"
                        id="explanationHtmlUse-1"
                        value={1}
                        disabled={!explanationUse}
                        checked={explanationHtmlUse == 1}
                        onChange={this.onChange}
                        label='HTMLを使用する'></Form.Check>
                    </Col>
                  </Col>
                  <Col sm={12} className="margin-top-10 padding-left-right-clear margin-bottom-10">
                    {contentExplanation}
                  </Col>
                </Col>
              </Col>
            </Form.Group>
          )}
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label}>
                ヒントを使用する
              </Col>
              <Col sm={2}>
                <Form.Check
                  type='checkbox'
                  className="margin-top-10"
                  checked={hintUse}
                  name="hintUse"
                  id="hintUse"
                  onChange={this.onCheckBox} />
              </Col>
            </Col>
          </Form.Group>
          {hintUse && (
            <Form.Group className="form-info" disabled={!hintUse}>
              <Col sm={12} className="padding-left-right-clear">
                <Col as={Form.Label} sm={2} />
                <Col as={Form.Label} sm={2} className="form-label">内容</Col>
                <Col sm={7}>
                  <Col sm={12} className="padding-left-right-clear">
                    <Col sm={6} className="padding-left-right-clear">
                      <Form.Check
                        type='radio'
                        inline
                        className="padding-top-10"
                        name="hintHtmlUse"
                        id="hintHtmlUse-0"
                        value={0}
                        disabled={!hintUse}
                        checked={hintHtmlUse == 0}
                        onChange={this.onChange}
                        label='HTMLを使用しない'></Form.Check>
                    </Col>
                    <Col sm={6} className="padding-left-right-clea">
                      <Form.Check
                        type='radio'
                        className="padding-top-10"
                        inline
                        name="hintHtmlUse"
                        id="hintHtmlUse-1"
                        value={1}
                        disabled={!hintUse}
                        checked={hintHtmlUse == 1}
                        onChange={this.onChange}
                        label='HTMLを使用する'></Form.Check>
                    </Col>
                  </Col>
                  <Col sm={12} className="margin-top-10 padding-left-right-clear margin-bottom-10">
                    {contentHint}
                  </Col>
                </Col>
              </Col>
            </Form.Group>
          )}
          { showQuestionAttributes &&
            <Form.Group className="form-info">
              <Col sm={12} className="padding-left-right-clear">
                <Col sm={4} as={Form.Label}>問題属性</Col>
                <Col sm={8} className="padding-right-10">
                  <Table striped hover>
                    <thead>
                      <TableHead data={thead} />
                    </thead>
                    <tbody>
                      {showQuestionAttributes}
                    </tbody>
                  </Table>
                </Col>
              </Col>
            </Form.Group>
          }
        </div>
      );
    } else {
      buttonText = 'plus';
    }
    return (
      <div>
        <Form className='form-horizontal'>
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col sm={4} as={Form.Label} className="padding-left-10" style={{ marginLeft: '-5px' }}>
                <a role="presentation" className={buttonText} onClick={onOpenOrCloseSetting}>
                  詳細設定
                </a>
              </Col>
            </Form.Group>
            {contentSetting}
          </Col>
        </Form>
        <Col sm={12} className="text-center margin-top-10 margin-bottom-10">
          <Button
            variant="default"
            className="btn-96 margin-right-10"
            onClick={this.props.goBackToDetail}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96" onClick={onOkBtnClick}>
            OK
          </Button>
        </Col>
      </div>
    );
  }
}

export default ContentQuestionEditBigFooter;
